import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EnsoMark } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = (location.hash || "").match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/enquiries", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    fetch(`${API}/auth/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("session exchange failed");
        return res.json();
      })
      .then((user) => navigate("/enquiries", { replace: true, state: { user } }))
      .catch(() => navigate("/enquiries", { replace: true, state: { authError: true } }));
  }, [location.hash, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-paper">
      <EnsoMark className="h-10 w-10 animate-pulse text-jade" />
    </div>
  );
};

export default AuthCallback;